import { DefaultError } from 'errors/DefaultError';
import type { ErrorResponse, NormalizedResponseError } from './types';
export class ApiError extends DefaultError {
  constructor({
    error,
    message,
    title
  }: {
    error?: ErrorResponse;
    message?: string;
    title?: string;
  }) {
    const shortMsg = `${error?.config?.method?.toUpperCase()} ${
      error?.config?.url
    } ${error?.status} (${error?.statusText})`;

    super({
      error: new Error(shortMsg),
      name: ApiError.name,
      message: message ?? `${shortMsg} ${JSON.stringify(error)}`,
      title
    });
    const errorsArray: NormalizedResponseError[] = error?.data?.errors?.length
      ? error.data.errors
      : [];
    this.response = { errors: errorsArray };
  }

  static get name() {
    return 'ApiError';
  }
}
